jQuery(document).ready(function($) {
  "use strict";
    if ($(".tf-sw-top_bar").length > 0) {
        var tfSwTopbar = $(".tf-sw-top_bar");
        var preview = 1;
        var spacing = 15;
        var loop = tfSwTopbar.data("loop");
        var speed = tfSwTopbar.data("speed");
        var play = tfSwTopbar.data("auto-play");
        var delay = tfSwTopbar.data("delay");
        var swiper = new Swiper(".tf-sw-top_bar", {
            autoplay: {
                delay: delay,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
            },
            observer: true,
            observeParents: true,
            autoplay: play,
            slidesPerView: preview,
            loop: loop,
            spaceBetween: spacing,
            speed: speed,
            navigation: {
                clickable: true,
                nextEl: ".nav-prev-topbar",
                prevEl: ".nav-next-topbar",
            },
        });

        tfSwTopbar.hover(
            function () {
                this.swiper.autoplay.stop();
            },
            function () {
                this.swiper.autoplay.start();
            }
        );
    }

    var selectImages = function () {
        if ($(".image-select").length > 0) {
            const selectIMG = $(".image-select");

            selectIMG.find("option").each((idx, elem) => {
                const selectOption = $(elem);
                const imgURL = selectOption.attr("data-thumbnail");
                if (imgURL) {
                    selectOption.attr(
                        "data-content",
                        `<img src="${imgURL}" /> ${selectOption.text()}`
                    );
                }
            });
            selectIMG.selectpicker();
        }
    };
    
    $(function () {
        selectImages();       
    });

})